<template>
  <div>
    <div class="bg-white shadow-sm fixed-top PcDevice pb-1">
      <nav class="navbar  navbar-expand-lg mx-5 py-0">
        <!-- 目前是非登入狀態所以先關閉，要判定當開展時就要連到Home -->

        <a class="navbar-brand WidthLongLogo">
          <img src="../../assets/images/Exhibition_Logo.png" height="85px" alt="" />
        </a>

        <a class="navbar-brand WidthShortLogo">
          <img src="../../assets/images/Exhibition_Logo.png" height="85px" alt="" />
        </a>

        <div class="collapse navbar-collapse">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item active"></li>
          </ul>

          <div v-if="isLogin">
            <button class="btn btn-warning px-5 py-2" @click.prevent="logout()">
              Logout
            </button>
          </div>
        </div>
      </nav>
    </div>

    <div class="bg-white shadow-sm fixed-top MbDevice">
      <div class="container ">
        <div class="row justify-content-between align-items-center">
          <div class="col-6 text-left">
            <router-link to="/Landing">
              <a class="navbar-brand py-0">
                <img src="../../assets/images/Exhibition_Logo.png" height="70px" alt="" />
              </a>
            </router-link>
          </div>

          <div class="col-6 text-right" v-if="isLogin">
            <button class="btn btn-warning px-4 py-2" @click.prevent="logout()">
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="text-white lobby_bg titleMargin">
      <div class="container-fluid">
        <!-- 未開展專區 -->
        <div v-if="OnlineExpoStatus == 1">
          <div class="row justify-content-start">
            <div class="col-lg-6 mx-4">
              <p>&zwnj;</p>
              <p>&zwnj;</p>

              <div v-if="!isLogin">
                <div class=" loginAllfont_1">
                  <div class="loginTopfont_1 mt-4">
                    Touch Taiwan – the Future
                  </div>

                  <div class="mt-4 mb-3">
                    The online exhibition will be held from April 27 to May 3.
                  </div>

                  <div class="my-4">
                    Log in to keep in touch with the universe of display.
                  </div>
                </div>
              </div>

              <div v-if="isLogin && !isRegister">
                <div class="registerAllfont_1">
                  <div class="loginTopfont_1 mt-4">
                    Touch Taiwan – the Future
                  </div>

                  <div class="my-3">
                    The online exhibition will be held from April 27 to May 3.
                  </div>
                  <div class="mt-3 mb-4">
                    Pre-register now to receive the latest information.
                  </div>
                </div>
              </div>

              <div v-if="isLogin && isRegister">
                <div class="doneAllfont_1">
                  <div class="doneTopfont_1 mt-2">
                    Touch Taiwan will see you very soon!
                  </div>

                  <div class="my-3">You can visit the online exhibition from April 27 to May 3.</div>

                  <div class="my-3">
                    For further information, please go to Touch Taiwan official website.
                  </div>
                </div>
              </div>

              <p>&nbsp;</p>
              <div v-if="isLogin && !isRegister">
                <div class="btn btn-light px-5 py-3 mt-4" style="font-size:18px" @click="toRegistration">
                  Pre-register
                </div>
              </div>

              <div v-if="!isLogin">
                <router-link to="/Login">
                  <div class="btn btn-light px-5 py-3 mt-4" style="font-size:19px">Login</div>
                </router-link>
              </div>

              <div v-if="isLogin && isRegister">
                <a href="https://www.touchtaiwan.com/en/" target="_blank">
                  <div class="btn btn-light px-5 py-3 mt-4" style="font-size:18px">
                    Official Website
                  </div>
                </a>
              </div>
            </div>

            <div class="col-5 PcDevice"></div>
          </div>
        </div>
        <!-- 已開展 -->
        <div v-if="OnlineExpoStatus == 2">
          <div class="row justify-content-start">
            <div class="col-lg-6 mx-4">
              <p>&zwnj;</p>
              <p>&zwnj;</p>

              <div v-if="!isLogin">
                <div>
                  <div class="loginTopfont_2 my-4">
                    Touch Taiwan – Visit Now
                  </div>

                  <div class="my-3 loginAllfont_2">
                    The online exhibition is online from now to May 3.
                  </div>

                  <div class="my-3 loginAllfont_2">
                    Log in to connect to the universe of display technology.
                  </div>

                  <!-- <p class=" mt-4  loginTimefont_2">
                    19 - 28 July, 2021
                  </p>
                  <div class="Opentime mb-3">（The Online Expo will be available on 19 July at 10:00(GMT+8)）</div> -->
                </div>
              </div>

              <div v-if="isLogin && !isRegister">
                <div class="registerAllfont_2">
                  <div class="registerTopfont_2 my-4">
                    One more step to Touch Taiwan
                  </div>

                  <div class="mt-4">
                    Register now to access the online exhibition.
                  </div>

                  <div class="mb-4 mt-2">
                    The universe of display technology is waiting for you !
                  </div>

                  <!-- <p class="mt-4 mb-3 registerTimefont_2">
                    19 - 28 July, 2021
                  </p> -->
                </div>
              </div>

              <div v-if="isLogin && isRegister">
                <p>&zwnj;</p>
                <p>&zwnj;</p>
              </div>

              <p>&nbsp;</p>
              <div v-if="isLogin && !isRegister">
                <div class="btn btn-light px-5 py-3 mt-4" style="font-size:18px" @click="toRegistration">
                  Register Now
                </div>
              </div>

              <div v-if="!isLogin">
                <div class="btn btn-light px-5 py-3 mt-4" style="font-size:19px" @click="toLogin">Login</div>
              </div>
            </div>

            <div class="col-5 PcDevice">
              <!-- <div class="lobby_banner">
                <img src="../../assets/images/boothsonmobile.png" width="100%" alt="" />
              </div> -->
            </div>
          </div>
        </div>

        <!-- 展場結束 -->

        <div v-if="OnlineExpoStatus == 3">
          <div class="row justify-content-start">
            <div class="col-lg-6 mx-4">
              <p>&zwnj;</p>
              <p>&zwnj;</p>
              <div class="closeAllfont_3">
                <div class="closeTopfont_3 mt-4">
                  Touch Taiwan - See you in 2023
                </div>

                <div class="mt-4">
                  Thank you for participating
                </div>
                <!-- <div class="mt-3">
                  The second round will be started from 04 - 07 December,
                </div> -->

                <div class="mt-4 mb-3">
                  We look forward to seeing you next year !
                </div>

                <!-- <div class="mt-4">
                  Thank you!
                </div> -->
                <a href="https://www.touchtaiwan.com/en/" target="_blank">
                  <div class="btn btn-light px-5 py-3 mt-4" style="font-size:18px">
                    Official Website
                  </div>
                </a>
              </div>
            </div>

            <div class="col-5 PcDevice">
              <!-- <div class="lobby_banner">
                <img src="../../assets/images/boothsonmobile.png" width="100%" alt="" />
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        isLogin: false,
        isRegister: false,
        OnlineExpoStatus: '',
        Nowdate: '',
        ExpoBegin: '',
        ExpoEnd: '',
      }
    },

    methods: {
      toRegistration() {
        window.location.replace('https://www.chanchao.com.tw/touchtaiwan/onlineexpo/Registration')
      },

      toLogin() {
        window.location.replace('https://www.chanchao.com.tw/touchtaiwan/onlineexpo/Login')
      },

      logout() {
        const vm = this
        const url = 'https://www.chanchao.com.tw/apiLogin/v1/Logout'

        vm.$http.get(url).then(function(response) {
          alert('Logout successfully')

          window.location.replace('https://www.chanchao.com.tw/touchtaiwan/onlineexpo/Landing')
        })
      },

      toHomePage() {
        window.location.replace('https://www.chanchao.com.tw/touchtaiwan/onlineexpo/Home')
      },

      goLobby() {
        window.location.replace('https://www.chanchao.com.tw/touchtaiwan/onlineexpo/Home')
      },
    },

    computed: {
      ...mapGetters(['exhcode']),
    },

    created() {
      const vm = this

      //取得當前時間

      vm.$http
        .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/Exhibitions/DF2242F61B11D1929128800348BA5A45?lang=en`)
        .then((response) => {
          vm.Nowdate = Date.parse(new Date()).valueOf()
          vm.ExpoBegin = response.data.OnlineExpoBegin
          vm.ExpoEnd = response.data.OnlineExpoEnd

          if (vm.Nowdate < vm.ExpoBegin) {
            vm.OnlineExpoStatus = 1
          } else if (vm.Nowdate >= vm.ExpoBegin && vm.Nowdate <= vm.ExpoEnd) {
            vm.OnlineExpoStatus = 2
          } else if (vm.Nowdate > vm.ExpoEnd) {
            vm.OnlineExpoStatus = 3
          }
        })

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        let CSRFToken = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: CSRFToken,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      })

      const api = `https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated`
      vm.$http.post(api).then((response) => {
        if (response.data == 200) {
          vm.isLogin = true

          const registerApi = `https://www.chanchao.com.tw/apiOnlineExpo/v1/CheckRegister/${vm.exhcode}`
          vm.$http.post(registerApi).then((response) => {
            if (response.data == 200) {
              vm.isRegister = true
            } else if (response.data == 252) {
              vm.isRegister = false
            } else if (response.data == 251) {
              window.location.replace(`https://www.chanchao.com.tw/en/`)
            } else if (response.data == 253) {
              vm.isRegister = true
            } else if (response.data == 254) {
              vm.isRegister = true
            }
          })
        } else {
          vm.isLogin = false
        }
      })
    },
  }
</script>

<style lang="scss" scoped>
  .lobby_bg {
    background: url(../../assets/images/landing_bg.png);
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
    background-size: cover;

    height: 900px;
  }

  .lobby_banner {
    width: 600px;
    height: 350px;
    margin-top: 120px;
  }

  // 未開放第一區

  .loginAllfont_1 {
    font-size: 30px;
    font-weight: bold;
  }

  .loginTopfont_1 {
    font-size: 58px;
    color: yellow;
    font-style: italic;
  }

  .loginTimefont_1 {
    font-size: 48px;
  }

  .registerAllfont_1 {
    font-size: 30px;
    font-weight: bold;
  }

  .registerTopfont_1 {
    font-size: 50px;
    color: yellow;
    font-style: italic;
  }

  .doneAllfont_1 {
    font-size: 30px;
    font-weight: bold;
  }

  .doneTopfont_1 {
    font-size: 50px;
    color: yellow;
    font-style: italic;
  }

  // 已開展第二區

  .loginAllfont_2 {
    font-size: 30px;
    font-weight: bold;
  }

  .loginTopfont_2 {
    font-size: 48px;
    color: yellow;
    font-style: italic;
    font-weight: bold;
  }

  .loginTimefont_2 {
    font-size: 48px;
  }

  .registerAllfont_2 {
    font-size: 30px;
    font-weight: bold;
  }

  .registerTopfont_2 {
    font-size: 50px;
    color: yellow;
    font-style: italic;
  }

  .registerTimefont_2 {
    font-size: 45px;
  }

  // 畢展第三區

  .closeAllfont_3 {
    font-size: 30px;
    font-weight: bold;
  }

  .closeTopfont_3 {
    font-size: 52px;
    color: yellow;
    font-style: italic;
  }

  .titleMargin {
    margin-top: 88px;
  }

  .Opentime {
    font-size: 19px;
  }

  @media screen and (min-width: 1150px) and (max-width: 1500px) {
    .Opentime {
      font-size: 17px;
    }

    .loginAllfont_1 {
      font-size: 21px;
      font-weight: bold;
    }

    .loginTopfont_1 {
      font-size: 32px;
      color: yellow;
      font-style: italic;
    }

    .loginTimefont_1 {
      font-size: 26px;
    }

    .registerAllfont_1 {
      font-size: 25px;
      font-weight: bold;
    }

    .registerTopfont_1 {
      font-size: 34px;
      color: yellow;
      font-style: italic;
    }

    .doneAllfont_1 {
      font-size: 22px;
      font-weight: bold;
    }

    .doneTopfont_1 {
      font-size: 32px;
      color: yellow;
      font-style: italic;
    }

    .loginAllfont_2 {
      font-size: 24px;
      font-weight: bold;
    }

    .loginTopfont_2 {
      font-size: 32px;
      color: yellow;
      font-style: italic;
    }

    .loginTimefont_2 {
      font-size: 30px;
    }

    .registerAllfont_2 {
      font-size: 25px;
      font-weight: bold;
    }

    .registerTopfont_2 {
      font-size: 32px;
      color: yellow;
      font-style: italic;
    }

    .registerTimefont_2 {
      font-size: 38px;
    }

    .closeAllfont_3 {
      font-size: 28px;
      font-weight: bold;
    }

    .closeTopfont_3 {
      font-size: 47px;
      color: yellow;
      font-style: italic;
    }
  }

  @media screen and (min-width: 577px) and (max-width: 1150px) {
    .Opentime {
      font-size: 15px;
    }
    .loginTopfont_1 {
      font-size: 30px;
      color: yellow;
      font-style: italic;
    }
    .loginAllfont_1 {
      font-size: 20px;
      font-weight: bold;
    }
    .loginTimefont_1 {
      font-size: 30px;
    }

    .registerAllfont_1 {
      font-size: 20px;
      font-weight: bold;
    }

    .registerTopfont_1 {
      font-size: 30px;
      color: yellow;
      font-style: italic;
    }

    .doneAllfont_1 {
      font-size: 20px;
      font-weight: bold;
    }

    .doneTopfont_1 {
      font-size: 30px;
      color: yellow;
      font-style: italic;
    }

    .loginAllfont_2 {
      font-size: 20px;
      font-weight: bold;
    }

    .loginTopfont_2 {
      font-size: 30px;
      color: yellow;
      font-style: italic;
    }

    .loginTimefont_2 {
      font-size: 30px;
    }

    .registerAllfont_2 {
      font-size: 20px;
      font-weight: bold;
    }

    .registerTopfont_2 {
      font-size: 30px;
      color: yellow;
      font-style: italic;
    }

    .registerTimefont_2 {
      font-size: 30px;
    }

    .closeAllfont_3 {
      font-size: 20px;
      font-weight: bold;
    }

    .closeTopfont_3 {
      font-size: 30px;
      color: yellow;
      font-style: italic;
    }
  }

  @media screen and (max-width: 576px) {
    .Opentime {
      font-size: 14px;
    }
    .titleMargin {
      margin-top: 50px;
    }

    .loginAllfont_1 {
      font-size: 20px;
      font-weight: bold;
    }

    .loginTopfont_1 {
      font-size: 30px;
      color: yellow;
      font-style: italic;
    }

    .loginTimefont_1 {
      font-size: 23px;
    }

    .registerAllfont_1 {
      font-size: 20px;
      font-weight: bold;
    }

    .registerTopfont_1 {
      font-size: 25px;
      color: yellow;
      font-style: italic;
      margin-top: 20px;
    }

    .doneAllfont_1 {
      font-size: 20px;
      font-weight: bold;
    }

    .doneTopfont_1 {
      font-size: 28px;
      color: yellow;
      font-style: italic;
    }

    .loginAllfont_2 {
      font-size: 20px;
      font-weight: bold;
    }

    .loginTopfont_2 {
      font-size: 28px;
      color: yellow;
      font-style: italic;
    }

    .loginTimefont_2 {
      font-size: 28px;
    }

    .registerAllfont_2 {
      font-size: 20px;
      font-weight: bold;
    }

    .registerTopfont_2 {
      font-size: 27px;
      color: yellow;
      font-style: italic;
    }

    .registerTimefont_2 {
      font-size: 32px;
    }

    .closeAllfont_3 {
      font-size: 23px;
      font-weight: bold;
    }

    .closeTopfont_3 {
      font-size: 34px;
      color: yellow;
      font-style: italic;
    }
  }
</style>
